import PropTypes from 'prop-types';
import { Component } from 'react';

class ErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error.message };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <p>OOPS! something went wrong</p>
          {error && !import.meta.env.PROD && <p className="error-msg">{error}</p>}
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
